import { useViewportSize } from '@liscio/ui';

import { useDeviceClass } from 'providers/DeviceClassProvider';

/** Native uses its launch class; web retains the existing responsive breakpoint. */
export function useFirmViewMode() {
  const { isNative, deviceClass } = useDeviceClass();
  const { isMobile: viewportMobile } = useViewportSize();
  const isMobile = isNative ? deviceClass !== 'desktop' : viewportMobile;

  return { isMobile, isDesktop: !isMobile };
}
